export const downloadFile = async (fileUrl) => {
    try {
        const response = await fetch(`/api/download?fileUrl=${encodeURIComponent(fileUrl)}`);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const blob = await response.blob();
        const contentDisposition = response.headers.get("Content-Disposition");

        // Extract filename from Content-Disposition or use a fallback
        let fileName = "downloadedFile";
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch[1]) {
                fileName = fileNameMatch[1];
            }
        }

        // Create a temporary download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Free memory
        }, 100);
    } catch (error) {
        console.error("Error downloading file:", error);
        throw error; // Re-throw if you want calling code to handle it
    }
};
